import Icon from '@ant-design/icons';
import { ReactComponent as EditImg } from 'assets/img/other-icons/edit-icon.svg';
import { ReactComponent as ArchiveImg } from 'assets/img/other-icons/archive-icon.svg';
import { ReactComponent as ViewImg } from 'assets/img/other-icons/view-icon.svg';
import { ReactComponent as ResetImg } from 'assets/img/other-icons/reset-icon.svg';
import { ReactComponent as JobImg } from 'assets/img/other-icons/job-icon.svg';
import { ReactComponent as ErrorJobImg } from 'assets/img/other-icons/error-job-icon.svg';
import { ReactComponent as InvoiceImg } from 'assets/img/other-icons/open-invoice.svg';
import { ReactComponent as ClosedInvImg } from 'assets/img/other-icons/closed-invoice.svg';
import { ReactComponent as TotalAmtImg } from 'assets/img/other-icons/total-amount.svg';
import { ReactComponent as UserImg } from 'assets/img/other-icons/user.svg';
import { ReactComponent as CreditPriceImg } from 'assets/img/other-icons/creidt-price.svg';
import { ReactComponent as WaitingPriceImg } from 'assets/img/other-icons/waiting-approval.svg';
import { ReactComponent as UploadImg } from 'assets/img/other-icons/upload-icon.svg';
import { ReactComponent as DownloadImg } from 'assets/img/other-icons/downicon.svg';
import { ReactComponent as EyeImg } from 'assets/img/other-icons/eye-icon.svg';
import { ReactComponent as PayImg } from 'assets/img/other-icons/pay-icon.svg';
import { ReactComponent as ViewDocImg } from 'assets/img/other-icons/preview-doc-upload.svg';
import { ReactComponent as MessageImg } from 'assets/img/other-icons/message-icon.svg';
import { ReactComponent as BrainImg } from 'assets/img/other-icons/brain-icon.svg';
import { ReactComponent as RightArrowImg } from 'assets/img/other-icons/rightArrow-icon.svg';
import { ReactComponent as HippaImg } from 'assets/img/other-icons/hippa-icon.svg';
import { ReactComponent as EnergyImg } from 'assets/img/other-icons/energy-icon.svg';
import { ReactComponent as MouseImg } from 'assets/img/other-icons/mouse-icon.svg';
import { ReactComponent as WarningImg } from 'assets/img/other-icons/warning-icon.svg';
import { ReactComponent as DownChartImg } from 'assets/img/other-icons/down-chart.svg';
import { ReactComponent as QuestionMarkImg } from 'assets/img/other-icons/question-mark.svg';
import { ReactComponent as BarImg } from 'assets/img/other-icons/bar-icon.svg';
import { ReactComponent as DocumentImg } from 'assets/img/other-icons/document-icon.svg';
import { ReactComponent as UsersImg } from 'assets/img/other-icons/users-icon.svg';
import { ReactComponent as UserAddImg } from 'assets/img/other-icons/user-add-icon.svg';
import { ReactComponent as UploadsImg } from 'assets/img/other-icons/uploads.svg';
import { ReactComponent as FileCheckImg } from 'assets/img/other-icons/file-check-icon.svg';
import { ReactComponent as LabImg } from 'assets/img/other-icons/lab-icon.svg';
import {ReactComponent as ExternalLinkImg} from 'assets/img/other-icons/external-link.svg';
import {ReactComponent as DoubleCheckImg} from 'assets/img/other-icons/double-check-icon.svg';

const EditIcon = () => <Icon component={EditImg} />;
const ArchiveIcon = () => <Icon component={ArchiveImg} />;
const ViewIcon = () => <Icon component={ViewImg} />;
const ResetIcon = () => <Icon component={ResetImg} />;
const JobIcon = () => <Icon component={JobImg} />;
const ErrorJobIcon = () => <Icon component={ErrorJobImg} />;
const OpenInvoiceIcon = () => <Icon component={InvoiceImg} />;
const ClosedInvoiceIcon = () => <Icon component={ClosedInvImg} />;
const TotalAmountIcon = () => <Icon component={TotalAmtImg} />;
const CreditPriceIcon = () => <Icon component={CreditPriceImg} />;
const UserIcon = () => <Icon component={UserImg} />;
const WaitingIcon = () => <Icon component={WaitingPriceImg} />;
const UploadIcon = () => <Icon component={UploadImg} />;
const DownloadIcon = () => <Icon component={DownloadImg} />;
const EyeIcon = () => <Icon component={EyeImg} />;
const PayIcon = () => <Icon component={PayImg} />;
const DocViewIcon = () => <Icon component={ViewDocImg} />;
const MessageIcon = () => <Icon component={MessageImg} />;
const BrainIcon = () => <Icon component={BrainImg} />;
const RightArrowIcon = () => <Icon component={RightArrowImg} />;
const HippaIcon = () => <Icon component={HippaImg} />;
const EnergyIcon = () => <Icon component={EnergyImg} />;
const MouseIcon = () => <Icon component={MouseImg} />;
const QuestionMarkIcon = () => <Icon component={QuestionMarkImg} />;
const DownChartIcon = () => <Icon component={DownChartImg} />;
const WarningIcon = () => <Icon component={WarningImg} />;
const BarIcon = () => <Icon component={BarImg} />;
const DocumentIcon = () => <Icon component={DocumentImg} />;
const UsersIcon = () => <Icon component={UsersImg} />;
const UserAddIcon = () => <Icon component={UserAddImg} />;
const UploadsIcon = () => <Icon component={UploadsImg} />;
const FileCheckIcon = () => <Icon component={FileCheckImg} />;
const LabIcon = () => <Icon component={LabImg} />;
const ExternalLinkIcon=()=><Icon component={ExternalLinkImg}/>;
const DoubleCheckIcon=()=><Icon component={DoubleCheckImg}/>;

export {
    EditIcon, ArchiveIcon, ViewIcon, ResetIcon, JobIcon, ErrorJobIcon, UploadIcon, DownloadIcon,
    OpenInvoiceIcon, ClosedInvoiceIcon, TotalAmountIcon, UserIcon, CreditPriceIcon, WaitingIcon,
    EyeIcon, PayIcon, DocViewIcon, MessageIcon, BrainIcon, RightArrowIcon, HippaIcon, EnergyIcon,
    MouseIcon, QuestionMarkIcon, DownChartIcon, WarningIcon, BarIcon, DocumentIcon, UsersIcon,
    UserAddIcon, UploadsIcon, FileCheckIcon, LabIcon, ExternalLinkIcon, DoubleCheckIcon
};